<template>
	<div
		class="cell configurator-options__wrapper"
		v-if="!uploadsAreComplete || checked(option.id) || hasMultipleSpecifications">
		<div
			class="configurator-options__item cursor-pointer"
			:class="{'configurator-options__item--active' : checked(option.id)}"
			@click="selectFormat(option.id)">
			<img
				:src="imagePath"
				class="configurator-options__image"
				width="500" >
			<input
				:id="option.id"
				class="configurator-block__input input-field input-field--custom"
				type="radio"
				name="selectFormat"
				:checked="checked(option.id)">
			<span class="configurator__input-selectable"/>

			<p class="configurator-block__label cursor-pointer">
				<span
					v-if="uploadsAreComplete && isCustomSize && checked(option.id)">
					{{ customSize.width }} X {{ customSize.height }} mm (</span>
				{{ formatInfo.name }}
				<span
					v-if="uploadsAreComplete && isCustomSize && checked(option.id)">)</span>
			</p>
			<div class="indicator-container indicator-container--top">
				<span v-if="option.isBestChoice" class="best-choice--label">
					meest gekozen
				</span>
			</div>
			<div class="indicator-container indicator-container--bottom">
				<div
					class="indicator"
					v-if="hasOffsetAvailable">
					<tooltip
						hover
						tooltip-wrapper-class-name="tool-tip__wrapper--offset"
						content="Offset beschikbaar">
						<div class="indicator__icon tool-tip__arrow-hook" v-html="getSvg.icon.inkDrops" />
					</tooltip>
				</div>
			</div>
			<modal
				v-if="!disabled && !option.isOffTheShelf"
				title="Informatie & aanleverspecificaties"
				button-style="tooltip"
				button-text="Informatie"
				class="tool-tip__wrapper--absolute">
				<delivery-specification :format="option" />
			</modal>
		</div>
	</div>
</template>

<script>
import modal from "@/components/element/modal";
import deliverySpecification from "@/components/information/delivery-specification";
import orientation from "@/components/element/orientation";
import tooltip from "@/components/element/tooltip";
import { Events, pushEvent } from "@/helpers/tracking.js";

export default {
	name: "FormatOption",
	props: {
		"option": {
			type: Object,
			required: true
		},
		"disabled": {
			type: Boolean,
			default: false
		}
	},
	components: {
		modal,
		deliverySpecification,
		orientation,
		tooltip
	},
	computed: {
		imagePath () {
			if (!this.uploadsAreComplete || !this.checked(this.option.id)) {
				return this.option.iconPath;
			}

			if (this.previewUrl && this.previewUrl !== null) {
				return this.previewUrl;
			}

			if (this.option.iconPath) {
				return this.option.iconPath;
			}

			return null;
		},
		availableFormats () {
			return this.$store.getters.getAvailableFormats;
		},
		isSingleOption () {
			return this.availableFormats.length === 1;
		},
		hasMultipleSpecifications () {
			return this.$store.getters.getConfiguratorData.hasFormatMatches;
		},
		pngPath () {
			return this.option.pngPath;
		},
		pdfPath () {
			return this.option.pdfPath;
		},
		inDesignPath () {
			return this.option.inDesignPath;
		},
		pdfTemplatePath () {
			return this.option.pdfTemplatePath;
		},
		formatInfo () {
			return this.option.productSize;
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		selectedProduct () {
			return this.$store.getters.getSelectedProduct;
		},
		itemClass () {
			let classString = "";
			if (this.checked(this.option.id)) {
				classString += "configurator-options__item--active";
			}
			if (this.disabled) {
				classString += " disabled";
			}

			return classString;
		},
		uploadsAreComplete () {
			return this.$store.getters.uploadsAreComplete;
		},
		isCustomSize () {
			return this.$store.getters.isCustomSize;
		},
		customSize () {
			return this.$store.getters.getCustomSize;
		},
		previewUrl () {
			return this.$store.getters.getPreviewUrl;
		},
		showOrientation () {
			return this.$store.getters.showOrientation;
		},
		hasSeparateCover () {
			return this.$store.getters.hasSeparateCover;
		},
		hasOffsetAvailable () {
			return this.option.offsetPricings.length > 0;
		},
		getSvg () {
			return this.$store.getters.getSvg;
		}
	},
	methods: {
		selectFormat (value) {
			if (!this.selectedFormat.isCustomSize) {
				this.$store.commit("SET_CUSTOM_SIZE", { width: null, height: null });
			}

			this.$store.commit("SET_SELECTED_FORMAT", value);

			if (!this.selectedFormat.isCustomSize) {
				this.$store.commit("SET_STEP_VALID");
			}

			pushEvent(Events.SELECT_SIZE, {
				formatId: value,
				formatName: this.option.productSize.fullName,
				productId: this.selectedProduct.id,
				productName: this.selectedProduct.name
			});
		},
		checked (value) {
			return this.selectedFormat !== null
				? this.selectedFormat.id === value
				: false;
		}
	},
	mounted () {
		if (this.isSingleOption) {
			this.selectFormat(this.availableFormats[0].id);
		}
	}
};
</script>

<style lang="scss">
.configurator-options__item.disabled:not(.configurator-options__item--active)
  input {
  pointer-events: none;
}

.configurator-options__item.disabled:not(.configurator-options__item--active) {
  pointer-events: none;
}

.configurator-options__item.disabled:not(.configurator-options__item--active)
  .configurator-options__shape {
  opacity: 0.2;
}

.content-block__preview-image-holder {
  width: 100%;
  height: 0 !important;
  padding-top: 100%;
  position: relative;
  background: #ebf1f5;
}

.preview-image-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;

  img {
    width: auto;
    max-height: 100%;
    max-width: 100%;
    box-shadow: -3px 3px 10px 2px rgba(0, 0, 0, 0.15);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/format/format-option.vue